<template>
  <div class="view pa24">
    <!-- <el-drawer :visible.sync="drawerVisible" direction="rtl" size="350px" :show-close="false" :modal="false"
      :wrapperClosable="true" custom-class="warning-drawer">
      <div class="drawer-content">
        <div class="drawer-header">
          <h3>库存预警</h3>
        </div>
        <div class="drawer-body">
          <p>部分商品库存严重不足，请立即补货！</p>
        </div>
        <div class="drawer-footer">
          <el-button @click="drawerVisible = false">稍后处理</el-button>
          <el-button type="primary" @click="handleReplenish">去补货</el-button>
        </div>
      </div>
    </el-drawer> -->

    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="name" class="mb10" style="width: 240px" placeholder="请输入产品类别名称" clearable />
            <el-input v-model="partNumber" class="mb10" style="width: 240px" placeholder="请输入件号/存货编码" clearable />
            <el-input v-model="specName" class="mb10" style="width: 240px" placeholder="请输入规格名称" clearable />
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="handleAddPageClass('add')"
              v-if="storeStatus == 0">+添加产品类别</el-button>
            <el-button class="ml10 mb10" type="primary" @click="importClass()"
              v-if="checkPermission(['importClass'])&&this.companyName.includes('五洲')">导入</el-button>
            <!-- 产品预警 -->
            <el-button class="ml10 mb10" type="primary" @click="handlePageClass()"
              v-if="this.companyName.includes('利佳')">产品预警</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%; margin-bottom: 20px" row-key="id" border lazy :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :expanded-keys="expandedKeys"
      @expand-change="handleExpandChange" ref="table">
      <el-table-column prop="name" align="center" label="名称" />
      <el-table-column prop="specName" align="center" label="规格">
        <template slot-scope="scope">
          {{ scope.row.specName || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="inventCode" align="center" label="库存编码" v-if="this.companyName.includes('五洲')">
        <template slot-scope="scope">
          {{ scope.row.inventCode || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="partNumber" align="center" label="件（图）号" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.partNumber || "--" }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="goodsCode" align="center" label="材料牌号" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.goodsCode || '--' }}
        </template>
      </el-table-column>    
       <el-table-column prop="specCode" align="center" label="缩略规格" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.specCode || '--' }}
        </template>
      </el-table-column> -->
      <el-table-column prop="modelNo" align="center" label="型号">
        <template slot-scope="scope">
          {{ scope.row.modelNo || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="heatNumber" align="center" label="炉号" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.heatNumber || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="unit" align="center" label="单位" />
      <el-table-column prop="stockWarningNum" align="center" label="库存预警数" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          <span class="text-danger">{{
            scope.row.stockWarningNum || "--"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="needSpare" align="center" label="是否备件" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.needSpare ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="gongcha" align="center" label="公差" v-if="this.companyName.includes('五洲')">
        <template slot-scope="scope">
          {{ scope.row.gongcha || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="areaWeight" align="center" label="面积/重量" v-if="this.companyName.includes('五洲')">
        <template slot-scope="scope">
          {{ scope.row.areaWeight || "--" }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序">
      </el-table-column>
      <el-table-column prop="createBy" align="center" label="操作人">
      </el-table-column>
      <el-table-column align="center" width="200" label="预警" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isWarn" @change="changeWarning(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)"
            v-if="storeStatus == 0 && !userInfo.branchId">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="delPageClass(scope.row)"
            icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text"
              v-if="storeStatus == 0 && !userInfo.branchId">删除</el-button>
          </el-popconfirm>
          <el-button slot="reference" class="ml10" @click="show(scope.row)" type="text">查看</el-button>
          <el-button slot="reference" class="ml10" @click="printClass(scope.row, 2)" type="text"
            v-if="scope.row.hasChildren">打印子级</el-button>
          <el-button slot="reference" class="ml10" @click="printClass(scope.row, 1)" type="text">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
    <!-- <commonTable
      :tableData="tableData"
      :total="total"

      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
          prop="name"
          align="center"
          label="名称"
        />
        <el-table-column
            prop="sort"
            align="center"
            label="排序"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
            <customPopconfirm confirm-button-text="确定" k cancel-button-text="取消"
                              @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
              <el-button slot="reference" class="ml10" style="color: #fd634e" type="text" >删除</el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable> -->
    <AddPageClassDialog ref="addPageClassDialog" @getList="getList"></AddPageClassDialog>
    <ImportClassDialog ref="importClassDialog" @getList="getList"></ImportClassDialog>
    <handlePageClassDialog ref="handlePageClassDialog" @getList="getList"></handlePageClassDialog>
    <class-print ref="classPrint"></class-print>
    <detailDialog ref="detailModel"></detailDialog>
    <!-- <GlobalWarningDrawer @replenish="handleReplenish" />  -->

  </div>
</template>

<script>
  import AddPageClassDialog from "./component/AddPageClassDialog";
  import GlobalWarningDrawer from "@/components/GlobalWarningDrawer.vue";

  import ClassPrint from "./component/classPrint.vue";
  // import commonTable from "@/components/common/commonTable";
  // import customPopconfirm from "@/components/common/customPopconfirm";
  import {
    deleteStoreClass,
    pageClassList,
    noPage,
    changeWarning,
    pageWarn,

  } from "@/api/customPageClass.js";
  import ImportClassDialog from "@/components/ImportClassDialog.vue";
  import handlePageClassDialog from "./component/handlePageClassDialog.vue";
  import { checkPermission } from "@/directives/permission";
  import detailDialog from "./component/detailDialog.vue";
  import user from "../businessManagement/user.vue";
  export default {
    components: {
      ClassPrint,
      detailDialog,
      // commonTable,
      AddPageClassDialog,
      ImportClassDialog,
      handlePageClassDialog,

      // customPopconfirm
    },
    props: {
      classType: {
        default: 0,
      },
      storeStatus: {
        default: "0",
      },
    },
    data() {
      return {
        name: null,
        partNumber: "",
        companyName: (() => {
          const companyList = JSON.parse(
            localStorage.getItem("info")
          ).companyList;
          if (companyList) {
            try {
              const parsedCompanyList = companyList;
              return parsedCompanyList[0] ? parsedCompanyList[0].companyName : "";
            } catch (e) {
              console.error("解析 companyList 失败:", e);
              return "";
            }
          }
          return "";
        })(),
        specName: "",
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        currentPage: 1,
        status: "",
        typeList: [
          { value: 0, label: "钢板" },
          { value: 1, label: "卷材" },
        ],
        parentId: "",
        userInfo: "",
        drawerVisible: false,
        expandedKeys: [],
      };
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem("info"));
      this.userInfo = userInfo;
      if(this.userInfo.companyName){
        this.companyName = this.userInfo.companyName
      }
      this.getList();
      this.checkWarnings(); // 页面加载时检查预警
    },
    methods: {
      // handleReplenish() {
      //   // 处理去补货的逻辑，比如跳转到特定页面
      //   this.$router.push('/storePageClass'); // 或其他相关页面
      // },
      checkPermission,
      load(tree, treeNode, resolve) {
        setTimeout(() => {
          let params = {
            noPage: true,
            type: this.classType,
            name: this.name,
            specName: this.specName,
            partNumber: this.partNumber,
            classType: 0,
            status: this.storeStatus,
            parentId: tree.id,
          };
          pageClassList(params).then((res) => {
            // 将 isWarn 转换为布尔类型
            const list = res.data.list.map((item) => ({
              ...item,
              isWarn: item.isWarn === 1,
            }));
            resolve(list);

            // 子节点加载完成后检查是否需要展开
            this.$nextTick(() => {
              list.forEach((child) => {
                if (this.expandedKeys.includes(child.id)) {
                  // 展开当前子节点
                  this.$refs.table.toggleRowExpansion(child, true);
                }
              });
            });
          });
        }, 1000);
      },
      handleExpandChange(row, expanded) {
        if (expanded) {
          // 展开时添加ID到数组
          console.log("row", row);
          if (!this.expandedKeys.includes(row.id)) {
            this.expandedKeys.push(row.id);
          }
          console.log(this.expandedKeys, expanded, "truetrue");
        } else {
          // 收起时移除当前节点及其所有后代节点ID
          const removeIds = [row.id];
          const collectDescendants = (node) => {
            if (node.children && node.children.length) {
              node.children.forEach((child) => {
                removeIds.push(child.id);
                collectDescendants(child); // 递归收集所有后代
              });
            }
          };
          collectDescendants(row);
          this.expandedKeys = this.expandedKeys.filter(
            (id) => !removeIds.includes(id)
          );
        }
        this.$forceUpdate();
      },
      importClass() {
        //导入产品类别
        this.$refs.importClassDialog.openDialog(this.classType);
      },
      handlePageClass() {
        //导入产品类别
        // this.$refs.handlePageClassDialog.openDialog();
        this.$router.push({
          path: '/store/productWarning',
        })
      },
      printClass(row, type) {
        if (1 == type) {
          //单个
          this.$refs.classPrint.init([row]);
        } else if (2 == type) {
          //打印子级
          if (!row.hasChildren) {
            this.$message.error("该类别下没有子级");
            return;
          } else {
            if (!row.children || row.children.length <= 0) {
              let params = {
                noPage: true,
                type: this.classType,
                classType: 0,
                parentId: row.id,
              };
              pageClassList(params).then((res) => {
                if (res.data.list) {
                  this.$refs.classPrint.init(res.data.list);
                }
              });
            }
          }
        }
      },
      getStockNum(row, num) {
        num += row.stockNum;
        if (row.children && row.children.length > 0) {
          row.children.forEach((item) => {
            num += item.stockNum;
            this.getStockNum(item, num);
          });
        }
        return num;
      },
      show(row) {
        this.$refs.detailModel.openDialog(row.id);
      },
      getCustomer() {
        // this.getList()
        let params = {
          pageNum: 1,
          pageSize: this.pageSize,
          type: this.classType,
          name: this.name,
          classType: 0,
          status: this.storeStatus,
          parentId: this.parentId,
          partNumber: this.partNumber,
          specName: this.specName,
        };
        this.tableData = [];
        pageClassList(params).then((res) => {
          this.tableData = res.data.list;
          this.total = res.data.total;
        });
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddPageClass(type, id) {
        this.$refs.addPageClassDialog.openDialog(type, id, this.classType);
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: this.classType,
          name: this.name,
          classType: 0,
          status: this.storeStatus,
          parentId: this.parentId,
          partNumber: this.partNumber,
          specName: this.specName,
        };
        this.tableData = [];
        pageClassList(params).then((res) => {
          // 将 isWarn 转换为布尔类型
          const list = res.data.list.map((item) => ({
            ...item,
            isWarn: item.isWarn === 1,
          }));
          this.tableData = list;
          this.total = res.data.total;

          this.$nextTick(() => {
            if (this.expandedKeys.length > 0) {
              this.tableData.forEach((topRow) => {
                if (this.expandedKeys.includes(topRow.id)) {
                  this.$refs.table.toggleRowExpansion(topRow, true);
                }
              });
            }
          });
        });
      },
      findRow(data, id, maxDepth = 3, currentDepth = 1) {
        for (let item of data) {
          if (item.id === id) {
            return item;
          }
          // 如果有子节点且未超过最大深度限制，递归查找
          if (
            item.children &&
            item.children.length > 0 &&
            currentDepth < maxDepth
          ) {
            const found = this.findRow(
              item.children,
              id,
              maxDepth,
              currentDepth + 1
            );
            if (found) return found;
          }
        }
        return null;
      },
      editCustomer(data) {
        this.$refs.addPageClassDialog.openDialog("edit", data, this.classType);
      },
      delPageClass(data) {
        console.log(data);
        deleteStoreClass(data.id).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      },
      lookImg(row) {
        this.$router.push({
          path: "/classImgList",
          query: {
            id: row.id,
            name: row.name,
          },
        });
      },
      changeWarning(row) {
        let status = row.isWarn ? 1 : 0;
        changeWarning({ id: row.id, status: status }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            // this.getList()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      },
      checkWarnings() {
        pageWarn().then(res => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.drawerVisible = true;
          }
        }).catch(err => {
          console.error("获取预警信息失败:", err);
        });
      },
      handleReplenish() {
        this.drawerVisible = false;
        this.handlePageClass(); // 调用已有的产品预警方法
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ml10 {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }

  .drawer-content {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh / 6);
  }

  .drawer-header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;

    h3 {
      margin: 0;
      color: #e64545;
    }
  }

  .drawer-body {
    flex: 1;
    font-size: 16px;
    color: #333;
    margin: 10px 0;
    /* 调整上下边距 */
  }

  .drawer-footer {
    text-align: right;

    .el-button {
      margin-left: 10px;
    }
  }
</style>

<style>
  .warning-drawer {
    z-index: 2000 !important;
    top: 0 !important;
    /* 定位到顶部 */
    bottom: auto !important;
    height: calc(100vh / 5) !important;
  }

  /* 移除element-ui抽屉默认的padding */
  .warning-drawer .el-drawer__body {
    padding: 0;
  }

  /* 移除header和footer的默认边距 */
  .warning-drawer .drawer-header {
    margin-bottom: 10px;
  }

  .warning-drawer .drawer-footer {
    margin-top: 10px;
  }
</style>